import { clsx } from 'clsx';

export interface GenericPageShimmerProps {
  className?: string;
  dataId: string;
}

export function GenericPageShimmer({ className = '', dataId = '' }: GenericPageShimmerProps) {
  return (
    <div
      className={clsx('center-flex-col justify-center h-100', className)}
      data-id={`${dataId}-generic-page-shimmer`}
    >
      <div>
        <div className='shimmer shimmer-line' style={{ width: '100px', height: '8px' }} />
        <div className='shimmer shimmer-line mt-3' style={{ width: '300px', height: '12px' }} />
      </div>

      <div className='mt-7'>
        <div className='shimmer shimmer-line' style={{ width: '100px', height: '8px' }} />
        <div className='shimmer shimmer-line mt-3' style={{ width: '300px', height: '12px' }} />
      </div>
    </div>
  );
}
